import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyPurchase = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/purchases',

        partCategories: [],
        partCategoriesLoading: false,

        partBrands: [],
        partBrandsLoading: false,

        measurements: [],
        measurementsLoading: false,

        branches: [],
        branchesLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        partCategories: state => state.partCategories,

        partBrands: state => state.partBrands,

        measurements: state => state.measurements,

        branches: state => state.branches,
    },
};
